import React from 'react';
import MaterialSelect from '../components/materialSelect';
import Localization from '../helpers/localization';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import GlassWallContainer from '../containers/GlassWallContainer'

const GlassLayersIcon = () => (
    <svg viewBox="0 0 48 48" focusable="false">
        <path d="M24 5 43 15 24 25 5 15 24 5Z" />
        <path d="m8 22-3 2 19 10 19-10-3-2" />
        <path d="m8 31-3 2 19 10 19-10-3-2" />
    </svg>
);

const PaletteIcon = () => (
    <svg viewBox="0 0 48 48" focusable="false">
        <path d="M24 5C13.5 5 5 12.8 5 22.4 5 33.8 14.6 43 26.5 43h2.1c3.1 0 5.5-2.4 5.5-5.3 0-1.5-.7-2.9-1.8-3.9-.9-.8-.4-2.3.8-2.3h3.3c3.7 0 6.6-2.8 6.6-6.3C43 14 34.5 5 24 5Z" />
        <circle cx="14" cy="20" r="2.2" />
        <circle cx="20" cy="13" r="2.2" />
        <circle cx="29" cy="13" r="2.2" />
        <circle cx="35" cy="20" r="2.2" />
    </svg>
);
const GlassWallSelectionPage = ({ measurementsSkipped, glassMaterials, glassListMaterials, showPrices, doorMaterialChanged, doorHandnessChanged, glassListMaterialChanged, restoreDefaultGlassWall, glassPrice, doorTypeChanged, doorOptions, selectedMaterial, selectedGlassListMaterial, doorType, showMaterial,showListMaterial, doorImage, prevPage, nextPage }) => (
    <div className="page" id = "glassWallPage">
       <div> 
            {(doorType === "customGlassWall" && !measurementsSkipped) ? <GlassWallContainer></GlassWallContainer> : <img src={doorImage} className="img-fluid"></img>}                   
        </div>
        {(doorType === "customGlassWall" && !measurementsSkipped) && <button type="button" className="textAction" onClick={restoreDefaultGlassWall}>{Localization.restoreGlassWallDefaults}</button>}
        <button type="button" className="textAction" onClick={doorHandnessChanged}>{Localization.changeDoorHandedness}</button>
        {showPrices ? <div>Muutoksen vaikutus hintaan: {glassPrice.toFixed(2)}  &euro;</div> : ""}
        <MaterialSelect materials={doorOptions} onChange={doorTypeChanged} selected={doorType} columnNum={5} autoAdjustWidth={true} header={Localization.doorTypeSelectionLabel} ></MaterialSelect>
        {showMaterial ? (
            <Row className="glassMaterialSelectionRow">
                <Col md={showListMaterial ? 6: 12} className="glassMaterialSelectionColumn glassMaterialSelectionColumn--glass">
                     <MaterialSelect materials={glassMaterials} onChange={doorMaterialChanged} selected={selectedMaterial} header={Localization.glassMaterialHeader} headerIcon={<GlassLayersIcon />} />
                </Col>
                {showListMaterial ? (
                    <Col md={6} className="glassMaterialSelectionColumn glassMaterialSelectionColumn--list">
                        <MaterialSelect materials={glassListMaterials} onChange={glassListMaterialChanged} selected={selectedGlassListMaterial} header={Localization.fittingAndListColor} headerIcon={<PaletteIcon />} />
                    </Col>) : ""}
            </Row>
        ) : ""}

        <div className="changePhaseRow">
            <span className="orangeButton changePhaseButton" onClick={() => { prevPage() }}> <span className="buttonTxt">&#8592;  {Localization.prevPhase}</span></span>
            <span className="orangeButton changePhaseButton" onClick={() => { nextPage() }}> <span className="buttonTxt"> {Localization.nextPhase} &#8594;</span></span>
        </div>
    </div>);

export default GlassWallSelectionPage

